import type { RouteLocationRaw } from "vue-router";

/**
 * Página inicial de cada perfil. Aluno (e perfil sem página própria) fica em
 * "Meus Projetos" (`/projetos`); os demais vão para o painel deles.
 *
 * Usada ao abrir "Meus Projetos" e ao sair do "Ver como": o "Voltar a ser eu"
 * mandava para "/", que redireciona para "/projetos" — se o admin estava lá vendo
 * como o aluno, o endereço não mudava, a página não era recriada e a tela do aluno
 * ficava parada (relato do Erik, 07/10/2026).
 */
export function rotaInicialDoPerfil(perfil: string | null | undefined): RouteLocationRaw {
  if (perfil === "admin") return { name: "admin-dashboard" };
  if (perfil === "coordenador" || perfil === "secretaria" || perfil === "coordenador_tcc") {
    return { name: "coordenador-trabalhos" };
  }
  if (perfil === "orientador") return { name: "orientador-dashboard" };
  return "/projetos";
}
